import React from 'react';
import { Users, Globe, Star, Calendar } from 'lucide-react';

const SocialProofBar = () => {
  const stats = [
    { icon: Users, text: '2,400+ community members' },
    { icon: Globe, text: 'Episodes in 30+ countries' },
    { icon: Star, text: '★★★★★ rated podcast' },
    { icon: Calendar, text: 'New episodes Mon & Thu' },
  ];

  const duplicatedStats = [...stats, ...stats];

  return (
    <div className="bg-white border-y border-border/50 py-4 overflow-hidden">
      <div className="flex gap-12 marquee">
        {duplicatedStats.map((stat, idx) => (
          <div key={`${stat.text}-${idx}`} className="flex items-center gap-2 whitespace-nowrap">
            <stat.icon className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-foreground">{stat.text}</span>
            {idx < duplicatedStats.length - 1 && (
              <span className="text-muted-foreground mx-4">•</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialProofBar;